import { Button } from "@/components/ui/button";
import { useBootstrapQuery } from "@/features/market-data/queries";
import { apiClient } from "@/services/api/client";

export function ProfilePage() {
  const bootstrapQuery = useBootstrapQuery();
  const currentUser = bootstrapQuery.data?.current_user;
  const displayName = currentUser?.display_name || currentUser?.email || "Guest";
  const subtitle = currentUser?.email || currentUser?.phone_e164 || "未登录";

  async function handleLogout() {
    try {
      await apiClient.authLogout();
    } finally {
      window.location.assign("/auth/login");
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--bg)] px-4 py-8 text-[var(--text)]">
      <div className="w-full max-w-xl rounded-2xl border border-[var(--border)] bg-[#101318] p-6 shadow-2xl shadow-black/30">
        <div className="flex items-center gap-4">
          <UserAvatar avatarUrl={currentUser?.avatar_url} displayName={displayName} size="lg" />
          <div>
            <div className="text-2xl font-semibold text-slate-100">{displayName}</div>
            <div className="mt-1 text-sm text-[var(--muted)]">{subtitle}</div>
          </div>
        </div>

        <div className="mt-6 grid gap-4 rounded-xl border border-[var(--border)] bg-[#0d1015] p-4 text-sm">
          <InfoRow label="状态" value={currentUser?.status || "GUEST"} />
          <InfoRow label="角色" value={currentUser?.is_admin ? "Admin" : "User"} />
          <InfoRow label="用户 ID" value={currentUser?.id ? String(currentUser.id) : "--"} />
        </div>

        <div className="mt-6 flex items-center justify-between">
          <Button variant="ghost" size="sm" className="h-9 rounded-md border border-[var(--border)] px-4 text-slate-200" onClick={() => window.location.assign("/stock")}>
            返回行情
          </Button>
          <div className="flex items-center gap-3">
            {!currentUser ? (
              <button className="text-sm text-[var(--muted)] hover:text-slate-100" onClick={() => window.location.assign("/auth/login")}>
                前往登录
              </button>
            ) : null}
            <Button variant="ghost" size="sm" className="h-9 rounded-md border border-[#4b232d] bg-[#231317] px-4 text-[#ffb4bf] hover:bg-[#2c171c]" onClick={() => void handleLogout()}>
              退出登录
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between border-b border-[var(--border)] pb-3 last:border-b-0 last:pb-0">
      <span className="text-[var(--muted)]">{label}</span>
      <span className="font-medium text-slate-100">{value}</span>
    </div>
  );
}

function UserAvatar({
  avatarUrl,
  displayName,
  size = "md",
}: {
  avatarUrl?: string | null;
  displayName: string;
  size?: "md" | "lg";
}) {
  const initials = displayName.trim().slice(0, 2).toUpperCase() || "U";
  const sizeClass = size === "lg" ? "size-16 text-xl" : "size-8 text-xs";

  if (avatarUrl) {
    return <img src={avatarUrl} alt={displayName} className={`${sizeClass} rounded-full object-cover ring-1 ring-white/10`} />;
  }

  return (
    <div className={`${sizeClass} flex items-center justify-center rounded-full bg-[#1b2430] font-semibold text-slate-100 ring-1 ring-white/10`}>
      {initials}
    </div>
  );
}
